<!--eslint-disable-->
<template>
  <div class="tag-status">
    <el-tag size="small" :type="type">{{str}}</el-tag>
  </div>
</template>
<script>
/* eslint-disable */
import {publishStatus, categoryStatus} from '@/filters/index';
export default {
  props: ["value", "filterType"],
  data () {
    return {
      statusData: {
        0 : {bj: 'rgba(0, 198, 201, 0.1)', color: '#00C6C9'},
        1 : {bj: 'rgba(60, 99, 217, 0.1)', color: '#3C63D9'},
        2 : {bj: 'rgba(191, 103, 48, 0.1)', color: '#BF6730'},
      }
    }
  },
  computed: {
    type() {
      const t = ['info', 'success']
      return t[this.value] || 'default'
    },
    str () {
      if (+this.filterType === 1) return this.publishStatus(this.value);
      if (+this.filterType === 2) return this.categoryStatus(this.value);
      return '--';
    },
    bjStyle () {
      return {
        background: this.statusData[+this.value].bj,
        color: this.statusData[+this.value].color
      }
    }
  },
  methods: {
    publishStatus,
    categoryStatus
  }
};
</script>

<style lang="scss" scoped>
.tag-status {
  ::v-deep {
    .el-tag {
      // height: 30px;
      padding: 0 18px;
    }
  }
}
</style>
